import type { ServiceRecordChangeField } from '../../types';

type ServiceRecordChangeLabelStrings = {
    SERVICE_RECORD_NOTES: string;
    SERVICE_RECORD_PART_SERIAL_NUMBER: string;
    SERVICE_RECORD_PERFORMED_DATE: string;
    SERVICE_RECORD_PHOTO_ADDED: string;
    SERVICE_RECORD_PHOTO_REMOVED: string;
};

// Display labels for change-log entries, keyed by ServiceRecordChangeField — a mix of
// field labels (notes, serial, date) and photo add/remove event labels. Reuses the
// record-detail wording so an edited field reads the same in both views.
export const getServiceRecordChangeLabels = (
    strings: ServiceRecordChangeLabelStrings
): Record<ServiceRecordChangeField, string> => ({
    notes: strings.SERVICE_RECORD_NOTES,
    partSerialNumber: strings.SERVICE_RECORD_PART_SERIAL_NUMBER,
    performedAt: strings.SERVICE_RECORD_PERFORMED_DATE,
    photoAdded: strings.SERVICE_RECORD_PHOTO_ADDED,
    photoRemoved: strings.SERVICE_RECORD_PHOTO_REMOVED
});
